
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/articles/[id]",
      function () {
        return require("private-next-pages/airlines/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/articles/[id]"])
      });
    }
  